import type { IncidentId } from '../realtime/contracts';

export type SubscribeToIncidentStreams = (incidentId: IncidentId) => Promise<void>;

export class IncidentStreamSubscriptions {
  private readonly watchCounts = new Map<IncidentId, number>();

  public constructor(
    private readonly subscribe: SubscribeToIncidentStreams,
    private readonly unsubscribe: SubscribeToIncidentStreams,
  ) {}

  public get watched(): readonly IncidentId[] {
    return [...this.watchCounts.keys()];
  }

  public async watch(incidentId: IncidentId): Promise<void> {
    const watched = this.watchCounts.get(incidentId) ?? 0;
    this.watchCounts.set(incidentId, watched + 1);

    if (watched === 0) {
      await this.subscribe(incidentId);
    }
  }

  public release(incidentId: IncidentId): Promise<void> | null {
    const watched = this.watchCounts.get(incidentId) ?? 0;
    if (watched > 1) {
      this.watchCounts.set(incidentId, watched - 1);
      return null;
    }

    this.watchCounts.delete(incidentId);
    return this.unsubscribe(incidentId);
  }

  public clear(): void {
    this.watchCounts.clear();
  }
}
